import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from '../../Apis/Axios';
import { toast } from 'react-toastify';
import { UploadImage } from '../ShareSlice/shareApi';
import { UploadProviderVehicleImage } from '../Providers/providersApi';
import { createImgObj, getSelfie } from '../CompanyEmployees/CompanyEmployeesApi';
import { t } from 'i18next';
import {accessMethodModel} from "../../enums/accessMethodEnum";
import {ASSETS_SERVICE, COMPANY_SERVICE, CONTRACT_SERVICE, CONTRACTOR_EMPLOYEE_SERVICE, CONTRACTOR_SERVICE, CONTRACTOR_VEHICLE_SERVICE, DOCUMENT_SERVICE, EXTRA_DATA_SERVICE, IMAGE_SERVICE, STATUS_SERVICE, USER_SERVICE, VEHICLE_SERVICE} from "../EndPoints";
import { TABLES } from '../../Apis/Tables';

//Update User
export const UpdateUserExtraData = createAsyncThunk('contractor/UpdateUserExtraData', async (params) => {
    const { id, body } = params;
    let result = await apiInstance
        .put(`${EXTRA_DATA_SERVICE.updateUserExtraData}${id}`, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});


//Get User By User id
export const GetUserDetailByUserId = createAsyncThunk('contractor/GetUserDetailByUserId', async (contractID) => {
    let result = await apiInstance
        .get(`${USER_SERVICE.getUserDetailByUserId}${contractID}`)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
                // toast.success("Fail contractor get by id");
            }
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});
//Get contract By contractor ID
export const GetByUserId = createAsyncThunk('contractor/GetByUserId', async (userId) => {
    let result = await apiInstance
        .get(`${CONTRACTOR_SERVICE.getByUserId}${userId}`)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
                // toast.success("Fail contractor get by id");
            }
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

// Get Contract Details V2
export const GetContractByIdV2 = createAsyncThunk('contractor/getContractByIdV2', async (contractID) => {
    const result = await apiInstance
        .get(`${CONTRACT_SERVICE.getContractByIdV2}${contractID}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

// Get vehicle work on Contract
export const GetVehicleOnContractById = createAsyncThunk('contractor/GetVehicleOnContractById', async (param) => {
    const { id, contractPagination } = param;
    const result = await apiInstance
        .post(`${CONTRACTOR_VEHICLE_SERVICE.getVehicleOnContractById}${id}`, contractPagination)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
            }
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const CreatelistofContractorEmployeeContract = createAsyncThunk(
    'contractor/CreatelistofContractorEmployeeContract',
    async (body) => {
        const result = await apiInstance
            .post(CONTRACTOR_EMPLOYEE_SERVICE.createlistofContractorEmployeeContract, body)
            .then(function (response) {
                if (response.status == 201 || response.status == 200) {
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

//
export const GetEmployeOnContractById = createAsyncThunk('contractor/getEmployeeOnContractById', async (param) => {
    const { id, contractPagination } = param;
    const result = await apiInstance
        .post(
            `${CONTRACTOR_EMPLOYEE_SERVICE.getEmployeOnContractById}${id}`,
            contractPagination,
        )
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
            }
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const GetlistofcontractorEmployees = createAsyncThunk('contractor/GetlistofcontractorEmployees', async (id) => {
    const result = await apiInstance
        .get(`${CONTRACTOR_EMPLOYEE_SERVICE.getlistofcontractorEmployees}${id}`)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
            }
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const GetlistofEmployeWorkOnContract = createAsyncThunk(
    'contractor/GetlistofEmployeWorkOnContract',
    async (id) => {
        const result = await apiInstance
            .get(`${CONTRACTOR_EMPLOYEE_SERVICE.getlistofEmployeWorkOnContract}${id}`)
            .then(function (response) {
                if (response.status == 201 || response.status == 200) {
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const DeleteEmployeeContractByContractAndUserID = createAsyncThunk(
    'contractor/DeleteEmployeeContractByContractAndUserID',
    async (body) => {
        const { contractId, userId } = body;
        const result = await apiInstance
            .delete(CONTRACTOR_EMPLOYEE_SERVICE.deleteEmployeeContractByContractAndUserID(contractId, userId))
            .then(function (response) {
                if (response.status == 201 || response.status == 200) {
                    toast.success(t('has_been_removed_successfully'));
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const DeleteEmployeeByContractAndUserList = createAsyncThunk(
    'contractor/deleteEmployeeByContractAndUserList',
    async ({ contractId, userIds }) => {
        // const { contractId, userIds } = body
        const result = await apiInstance
            .post(CONTRACTOR_EMPLOYEE_SERVICE.deleteEmployeeByContractAndUserList(contractId), userIds)
            .then(function (response) {
                if (response.status == 201 || response.status == 200) {
                    toast.success(t('has_been_removed_successfully'));
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const DeleteVehicleByContractAndVehicleList = createAsyncThunk(
    'contractor/deleteVehicleByContractAndVehicleList',
    async ({ contractId, vehicleIds }) => {
        // const { contractId, userIds } = body
        const result = await apiInstance
            .post(CONTRACTOR_VEHICLE_SERVICE.deleteVehicleByContractAndVehicleList(contractId), vehicleIds)
            .then(function (response) {
                if (response.status == 201 || response.status == 200) {
                    toast.success(t('has_been_removed_successfully'));
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// Get Vehicle Work On Contract

export const VehicleWorkOnContract = createAsyncThunk('contractor/VehicleWorkOnContract', async (contractId) => {
    const result = await apiInstance
        .get(`${CONTRACTOR_VEHICLE_SERVICE.vehicleWorkOnContract}${contractId}`)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
            }
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const DeleteVehicleWorkOnContract = createAsyncThunk('contractor/DeleteVehicleWorkOnContract', async (body) => {
    const { contractId, vehicleId } = body;
    const result = await apiInstance
        .delete(CONTRACTOR_VEHICLE_SERVICE.deleteVehicleWorkOnContract(contractId, vehicleId))
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
            }
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

// Get Vehicle Work On Contract

export const GetAllVehicleByContractor = createAsyncThunk(
    'contractor/GetAllVehicleByContractor',
    async (contractId) => {
        const result = await apiInstance
            .get(`${CONTRACTOR_VEHICLE_SERVICE.getAllVehicleByContractor}${contractId}`)
            .then(function (response) {
                if (response.status == 201 || response.status == 200) {
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// Delete Vehicle From Contract
export const DeleteVehicleFromContract = createAsyncThunk('contractor/DeleteVehicleFromContract', async (params) => {
    const { contractId, vehicleId } = params || {};
    const result = await apiInstance
        .get(`${CONTRACTOR_VEHICLE_SERVICE.deleteVehicleFromContract}${contractId}/by-vehicle-id/${vehicleId}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            toast(error?.response?.data?.message).toUpperCase();
            document.getElementById('overlay').style.display = 'none';
            return error.response;
        });

    const { data, status } = result;
    return { data, status };
});

export const CreateDocumentTitle = createAsyncThunk('contractor/CreateDocumentTitle', async (doc) => {
    const result = await apiInstance
        .post(DOCUMENT_SERVICE.createDocumentTitle, doc)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
                toast.success('Title Added SuccessFully');
            }
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const UploadExternalDocumentComment = createAsyncThunk(
    'contractor/UploadExternalDocumentComment',
    async (doc) => {
        const result = await apiInstance
            .put(DOCUMENT_SERVICE.uploadExternalDocumentComment, doc)
            .then(function (response) {
                if (response.status == 201 || response.status == 200) {
                    toast.success('Comment added SuccessFully');
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

/// ApI Releated //////////Vehicle   ///////////////////////

// Add Vehicle
export const AddNewVehicle = createAsyncThunk('contractor/AddNewVehicle', async (param) => {
    const { contactorId, body } = param;

    const result = await apiInstance
        .post(`${VEHICLE_SERVICE.addNewVehicle}${contactorId}`, body)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
                toast.success('Vehicle added successFully');
            }
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

// APi to Get Vehicle Fillter
export const GetVehicleFilter = createAsyncThunk('contractor/GetVehicleFilter', async () => {
    const result = await apiInstance
        .get(ASSETS_SERVICE.getVehicleFilter)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
            }
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

// Get List of vehicle by Contractor id

export const ContractorlistOfVehicles = createAsyncThunk(
    'contractor/contractorlistOfVehicles',
    async (params, { dispatch, getState }) => {
        const { contractorId } = params;
        const result = await apiInstance
            .post(`${CONTRACTOR_VEHICLE_SERVICE.contractorlistOfVehicles}${contractorId}`, params?.pagination)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// Get Vehicle Detail By Vehicle Detail
export const GetVehicleDetailById = createAsyncThunk('contractor/GetVehicleDetailById', async (id) => {
    const result = await apiInstance
        .get(`${CONTRACTOR_VEHICLE_SERVICE.getVehicleDetailById}${id}`)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
            }
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

// create document exernal value
export const CreateToExternalVehicle = createAsyncThunk(
    'contractor/createToExternalVehicle',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .post(DOCUMENT_SERVICE.createToExternalVehicle, params?.data)
            .then(function (response) {
                if (params?.file) {
                    const formData = new FormData();
                    formData.append('id', response?.data?.data?.id);
                    formData.append('option', 'contractor_vehicle_document');
                    formData.append('file', params?.file);
                    dispatch(UploadImage(formData));
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// create a vehicle and relationship with provider
export const CreateVehicleAndRelationContractor = createAsyncThunk(
    'contractor/createVehicleAndRelationContractor',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .post(
                `${VEHICLE_SERVICE.createVehicleAndRelationContractor}${sessionStorage.getItem('contractorId')}`,
                params?.vehicleData,
            )
            .then(function (response) {
                const imgData = {
                    vehicle: {
                        id: response?.data?.data?.vehicle?.id,
                    },
                    accessMethod: {
                        id: '5',
                    },
                    description: 'Face recognition',
                };
                // want to update or create image
                if (params?.imageFile) {
                    dispatch(UploadProviderVehicleImage({ imgData, file: params?.imageFile }));
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// set document exernal value
export const SetToExternalVehicle = createAsyncThunk(
    'contractor/setToExternalVehicle',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .put(DOCUMENT_SERVICE.setToExternalVehicle, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const UpdateVehicleData = createAsyncThunk('contractor/UpdateVehicleData', async (body) => {
    const result = await apiInstance
        .put(VEHICLE_SERVICE.updateVehicleData, body)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
            }
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const CreateRelationForVehicleImg = createAsyncThunk('contractor/CreateRelationForVehicleImg', async (body) => {
    const result = await apiInstance
        .post(VEHICLE_SERVICE.createRelationForVehicleImg, body)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
            }
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const CheckVehicleImgStatus = createAsyncThunk('contractor/CheckVehicleImgStatus', async (vehicleId) => {
    const result = await apiInstance
        .get(`${VEHICLE_SERVICE.checkVehicleImgStatus}${vehicleId}`)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
            }
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const GetVehicleImgUsingId = createAsyncThunk('contractor/GetVehicleImgUsingId', async (vehicleId) => {
    const result = await apiInstance
        .get(`${VEHICLE_SERVICE.getVehicleImgUsingId}${vehicleId}`)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
            }
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const GetAllVehicleByContractorId = createAsyncThunk('contractor/GetAllVehicleByContractorId', async (id) => {
    const result = await apiInstance
        .get(`${CONTRACTOR_VEHICLE_SERVICE.getAllVehicleByContractorId}${id}`)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
            }
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const AddVehicleWithContractId = createAsyncThunk('contractor/AddVehicleWithContractId', async (body) => {
    const result = await apiInstance
        .post(CONTRACTOR_VEHICLE_SERVICE.addVehicleWithContractId, body)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
            }
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

// Employee Section API

// Get Gender api
export const GetAllGender = createAsyncThunk('contractor/GetAllGender', async () => {
    const result = await apiInstance
        .get('gender-service/get-all')
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
            }
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});


export const GetUserDetailForUpdate = createAsyncThunk('contractor/GetUserDetailForUpdate', async (employeId) => {
    const result = await apiInstance
        .get(`${USER_SERVICE.getUserDetailForUpdate}${employeId}`)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
                // toast.success("use Detail get SuccessFully");
            }
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});


// Documents for contractors

export const GetAllContractorDocuments = createAsyncThunk('contractor/getAllContractorDocuments', async (id) => {
    const result = await apiInstance
        .get(`${DOCUMENT_SERVICE.getAllContractorDocuments}${id}`)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
            }
            return response;
        })
        .catch(function (error) {
            toast.error('Company restriction faild');
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

// create contractor document value
export const CreateContractorDocValue = createAsyncThunk(
    'contractor/createContractorDocValue',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .post(DOCUMENT_SERVICE.createContractorDocValue, params?.data)
            .then(function (response) {
                if (params?.file) {
                    const formData = new FormData();
                    formData.append('id', response?.data?.data?.id);
                    formData.append('option', 'contractor_document');
                    formData.append('file', params?.file);
                    dispatch(UploadImage(formData));
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// set cotractor document value
export const SetContractorDocValue = createAsyncThunk(
    'contractor/setContractorDocValue',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .put(DOCUMENT_SERVICE.setContractorDocValue, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// get contractor by user id
export const GetContractorsByUserId = createAsyncThunk(
    'contractor/getContractorsByUserId',
    async (params, { dispatch, getState }) => {
        const { userId } = params;
        const result = await apiInstance
            .get(`${CONTRACTOR_SERVICE.getContractorsByUserId}${userId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);


// details of contractor employee
export const GetContractorEmployeeDetail = createAsyncThunk(
    'contractor/getContractorEmployeeDetail',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .get(`${CONTRACTOR_EMPLOYEE_SERVICE.getContractorEmployeeDetail}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// check preregister user

// create employee contractor
export const CreateContractorEmployee = createAsyncThunk(
    'contractor/createContractorEmployee',
    async (params, { dispatch}) => {
        const result = await apiInstance
            .post(CONTRACTOR_EMPLOYEE_SERVICE.createContractorEmployee, params?.data)
            .then(async function (response) {
                const imgData = {
                    user: {
                        id: response?.data?.data?.userId,
                    },
                    accessMethod: {id: accessMethodModel.FACE_RECOGNITION.id},
                    description: 'Face recognition',
                };
                // want to update or create image
                if (params?.file) {
                    const {
                        payload: { data: { data: createdImg, success: imgSuccess } = {} } = {},
                    } = await dispatch(
                        createImgObj({
                            ...imgData,
                            file: params.file,
                        }),
                    );

                    if (imgSuccess) {
                        const formData = new FormData();

                        formData.append('id', createdImg?.id);
                        formData.append('option', TABLES.USER);
                        formData.append('file', params.file);

                        await dispatch(UploadImage(formData));
                    }
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

// get contractor info by id
export const GetContractorInfoById = createAsyncThunk(
    'contractor/getContractorInfoById',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .get(`${CONTRACTOR_EMPLOYEE_SERVICE.getContractorInfoById}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// update employee contractor
export const UpdateContractorEmployee = createAsyncThunk(
    'contractor/updateContractorEmployee',
    async (params, { dispatch }) => {
        const { setModified, data, file, updateImage } = params;

        try {
            const response = await apiInstance.put(
                CONTRACTOR_EMPLOYEE_SERVICE.updateContractorEmployee,
                data,
            );

            const userId = response?.data?.data?.userId;

            const imgData = {
                user: { id: userId },
                accessMethod: { id: accessMethodModel.FACE_RECOGNITION.id },
                description: 'Face recognition',
            };

            if (file) {
                let imageId = updateImage
                    ? (await dispatch(getSelfie(userId)).unwrap())?.data?.data?.id
                    : null;

                // No previous selfie: create the user image object to get its id
                if (!imageId) {
                    const {
                        payload: { data: { data: createdImg, success: imgSuccess } = {} } = {},
                    } = await dispatch(createImgObj({ ...imgData, file }));

                    if (imgSuccess) imageId = createdImg?.id;
                }

                if (imageId) {
                    const formData = new FormData();
                    formData.append('id', imageId);
                    formData.append('option', TABLES.USER);
                    formData.append('file', file);

                    await dispatch(UploadImage(formData));
                }
            }

            setModified(true);

            return {
                data: response.data,
                status: response.status,
            };
        } catch (error) {
            return {
                data: error?.response?.data,
                status: error?.response?.status,
            };
        }
    },
);
